// Design tokens do Riviera FC — derivados do escudo (carmesim, preto e branco).
const tokens = {
  color: {
    brand: '#D7263D',
    brandDark: '#A3172B',
    brandLight: '#F25C6E',
    brandSoft: '#FDECEE',
    ink: '#0E1116',
    inkSoft: '#1B2029',
    gold: '#E9A800',
    goldSoft: '#FFF6DB',
    success: '#1F9D55',
    successSoft: '#E6F6EC',
    warning: '#D97706',
    warningSoft: '#FEF3C7',
    danger: '#C62828',
    dangerSoft: '#FDECEC',
    info: '#2563EB',
    infoSoft: '#E8EFFE',
    bg: '#F4F5F7',
    surface: '#FFFFFF',
    surfaceAlt: '#F9FAFB',
    border: '#E6E8EC',
    text: '#111827',
    textMuted: '#5B6472',
    textInverse: '#FFFFFF',
    // Cores dos times na partida da pelada
    team1: '#D7263D',
    team2: '#1B2029',
  },
  font: {
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    display: "'Barlow Condensed', 'Inter', sans-serif",
  },
  radius: { sm: 8, md: 12, lg: 16, pill: 999 },
  shadow: {
    sm: '0 1px 2px rgba(16, 24, 40, 0.06)',
    md: '0 4px 12px rgba(16, 24, 40, 0.08)',
    lg: '0 12px 32px rgba(16, 24, 40, 0.12)',
  },
  layout: { maxWidth: 1200, headerHeight: 64 },
};

export default tokens;
